<script setup lang="ts">
import { ref, provide, onMounted } from 'vue';
import {
  CdrContainer, CdrText,
} from '@rei/cedar';
import HelpCentersVerticalCards from '../../../components/helpCentersVerticalCards/HelpCentersVerticalCards.vue';
import HelpCentersCategories from '../../../components/helpCenterCategories/helpCenterCategories.vue';
import { isPageOfType } from '../../../common/utils';

const displayColumns = ref<boolean>(false);
const HelpCenterId = ref<string>('');
const HelpCenterName = ref<string>('');
function setHelpCenterValue(name: string, id?:string) {
  HelpCenterName.value = name;
  HelpCenterId.value = id;
}
provide('centerId', {
  HelpCenterId,
  HelpCenterName,
  setHelpCenterValue,
});

onMounted(() => {
  const d = ['a', 'hc', 'ctgry'].map((type) => (isPageOfType(type)));
  displayColumns.value = !d.some((el) => el);
});
</script>

<template>
  <section v-show="displayColumns">
    <CdrContainer class="help-centers__heading">
      <CdrText
        tag="h2"
        tabindex="0"
        class="help-center__heading-links"
      >
        Explore all help topics
      </CdrText>
    </CdrContainer>
    <div class="help-centers__columns">
      <HelpCentersVerticalCards />
      <HelpCentersCategories />
    </div>
  </section>
</template>

<style lang="scss">
  @import 'src/main/style/helpCentersColumns.scss';
</style>
